module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAAPFBMVEUAAAD////////////////////////////////////////////////////////////////////////////YSWgTAAAAFHRSTlMAb//j58ejg0D7JLOTDNe/BJvfMMKdUFYAAAB6SURBVHgB7c3FAcNAAMTANTP332ueYdgL25oCJOFvAIjiC6K39v2D3/cPbj/8EAda04ABA/yG2MTgAAMGDBgwYMCAAQMGDBgwYMCAAYNErjS2ZHLlsaWQq4wdVS1bExta+bo+ftgwKuTQxA+aRoUp8zS+a54WAcCP2wFx9Bn37jyggwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete-icon.png
// module id = 31
// module chunks = 0